import gql from 'graphql-tag';


const CREATE_BRAND_PRESET = gql`
  mutation CreateBrandPreset($input: BrandPresetInput!) {
    createBrandPreset(input: $input) {
      brandPresetId
    }
  }
`;

const createBrandPresetMutation = () => ({
  mutation: CREATE_BRAND_PRESET,
  module: 'organisations',
  buildVariables: (input) => ({
    input
  })
});

export default createBrandPresetMutation;